import BemIt, { addClass } from "@gtechdoodler/bem-it";
import FlexBox from "../../../../../layout/boxes/FlexBox";
import { HtmlElementProps } from "../../../../../../types/globals";

const ListItemSnippet: React.FC<HtmlElementProps> = ({
	className,
	children,
	...props
}) => {
	const block = new BemIt("ListItemSnippet");

	return (
		<FlexBox
			className={addClass(className).after(block)}
			width="100%"
			{...props}
		>
			{children}
		</FlexBox>
	);
};

export default ListItemSnippet;
